function showLimitedNumberOfCards(){
    const cardsWrapper = $('.js-cards-wrapper');
    let gap = 20;

    if(window.matchMedia(`(min-width: 1440px)`).matches){
        gap = 20;
    } else if (window.matchMedia(`(min-width: 600px)`).matches){
        gap = 16;
    } else {
        gap = 8;
    }

    cardsWrapper.each(function(index){
        let arrayOffsetTop = [];
        let uniqueOffsetTop = [];

        $(this).find('.js-card').each(function(index, element) {
            const elementOffsetTop = $(element).offset().top;
            arrayOffsetTop.push(elementOffsetTop);
            uniqueOffsetTop = [...new Set(arrayOffsetTop)];
        });


        if(window.matchMedia(`(min-width: 960px)`).matches && uniqueOffsetTop.length > 2) {
            showVideCatalogShowMoreBtn($(this), uniqueOffsetTop.length, 2, gap);
        } else if(window.matchMedia(`(min-width: 440px)`).matches && uniqueOffsetTop.length > 3) {
            showVideCatalogShowMoreBtn($(this), uniqueOffsetTop.length, 3, gap);
        } else if(window.matchMedia(`(min-width: 0px)`).matches && uniqueOffsetTop.length > 6) {
            showVideCatalogShowMoreBtn($(this), uniqueOffsetTop.length, 6, gap);
        } else {
            hideVideCatalogShowMoreBtn($(this));
        }

        if($(this).hasClass('js-one-row')){
            if(window.matchMedia(`(min-width: 1440px)`).matches && uniqueOffsetTop.length > 1){
                showVideCatalogShowMoreBtn($(this), uniqueOffsetTop.length, 1, gap)
            }
        }

    });
}

runIfElementExist(showLimitedNumberOfCards, '.js-cards-wrapper');
resizeTimer(showLimitedNumberOfCards, '.js-cards-wrapper', 250);

function showVideCatalogShowMoreBtn(parent, totalRows, displayedRows, gap){
    let margin = (totalRows - displayedRows) * gap;

    parent.closest('.js-section').find('.js-show-more-btn-wrapper')
    .addClass('active')
    .css('margin-top', `-${margin}px`);
};

function hideVideCatalogShowMoreBtn(parent){
    parent.closest('.js-section').find('.js-show-more-btn-wrapper').removeClass('active');
};


function showAllCards(){
    $(document).on('click', '.js-video-catalog-show-more-btn', function(){
        $(this).closest('.js-section').find('.js-cards-wrapper').addClass('display-all');
        $(this).closest('.js-show-more-btn-wrapper').remove();
    });
}

showAllCards();
